import { useLanguage } from "@/contexts/LanguageContext";

const MiniAIIllustration = () => {
  const { t } = useLanguage();

  return (
    <div className="relative w-full max-w-lg mx-auto">
      <div className="bg-card rounded-lg shadow-lg border border-border p-6 relative flex flex-col">
        <h3 className="text-sm font-semibold text-center mb-3 z-10">
          {t.miniIllustrations.AI.header}
        </h3>
        <div className="relative flex items-center justify-center">
          <svg
            width="500"
            height="400"
            viewBox="0 0 500 400"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full h-full scale-75 sm:scale-85 md:scale-90 lg:scale-100 xl:scale-110 2xl:scale-125"
            style={{ transformOrigin: 'center center' }}
          >
            {/* Curved connecting lines with perpendicular entries/exits */}
            
            {/* Left top (100, 80) to Main hub (200, 230) */}
            <path
              d="M 115.89 101.21 C 125 135 140 170 170 200 C 185 215 188.94 215.89 188.94 215.89"
              stroke="hsl(var(--primary))"
              strokeWidth="20"
              strokeLinecap="round"
              fill="none"
            />
            
            {/* Center top (220, 100) to Main hub (200, 230) */}
            <path
              d="M 220 125 C 220 155 220 175 215 190 C 210 200 205.2 209.02 205.2 209.02"
              stroke="hsl(var(--primary))"
              strokeWidth="20"
              strokeLinecap="round"
              fill="none"
            />
            
            {/* Main hub (200, 230) to Left bottom (120, 340) */}
            <path
              d="M 178.79 244.11 C 165 255 145 280 135 305 C 130 320 124.11 324.11 124.11 324.11"
              stroke="hsl(var(--primary))"
              strokeWidth="20"
              strokeLinecap="round"
              fill="none"
            />
            
            {/* Main hub (200, 230) to Right center (290, 230) */}
            <path
              d="M 230 230 C 245 230 250 230 265 230"
              stroke="hsl(var(--primary))"
              strokeWidth="20"
              strokeLinecap="round"
              fill="none"
            />
            
            {/* Right center (290, 230) to Right top (420, 180) */}
            <path
              d="M 313.30 237.98 C 335 245 365 245 385 220 C 400 205 396.70 187.98 396.70 187.98"
              stroke="hsl(var(--primary))"
              strokeWidth="20"
              strokeLinecap="round"
              fill="none"
            />
            
            {/* Right center (290, 230) to Right bottom (410, 320) */}
            <path
              d="M 308.30 251.02 C 325 270 355 295 375 305 C 390 312 391.70 312.02 391.70 312.02"
              stroke="hsl(var(--primary))"
              strokeWidth="20"
              strokeLinecap="round"
              fill="none"
            />

            {/* Circular nodes */}
            
            {/* Left top node */}
            <circle cx="100" cy="80" r="25" fill="hsl(var(--card))" stroke="hsl(var(--primary))" strokeWidth="16" />
            <circle cx="100" cy="80" r="12" fill="transparent" />
            
            {/* Center top node */}
            <circle cx="220" cy="100" r="25" fill="hsl(var(--card))" stroke="hsl(var(--primary))" strokeWidth="16" />
            <circle cx="220" cy="100" r="12" fill="transparent" />
            
            {/* Left center node (main hub) */}
            <circle cx="200" cy="230" r="30" fill="hsl(var(--card))" stroke="hsl(var(--primary))" strokeWidth="16" />
            <circle cx="200" cy="230" r="15" fill="transparent" />
            
            {/* Left bottom node */}
            <circle cx="120" cy="340" r="25" fill="hsl(var(--card))" stroke="hsl(var(--primary))" strokeWidth="16" />
            <circle cx="120" cy="340" r="12" fill="transparent" />
            
            {/* Center right node */}
            <circle cx="290" cy="230" r="25" fill="hsl(var(--card))" stroke="hsl(var(--primary))" strokeWidth="16" />
            <circle cx="290" cy="230" r="12" fill="transparent" />
            
            {/* Right top node */}
            <circle cx="420" cy="180" r="25" fill="hsl(var(--card))" stroke="hsl(var(--primary))" strokeWidth="16" />
            <circle cx="420" cy="180" r="12" fill="transparent" />
            
            {/* Right bottom node */}
            <circle cx="410" cy="320" r="25" fill="hsl(var(--card))" stroke="hsl(var(--primary))" strokeWidth="16" />
            <circle cx="410" cy="320" r="12" fill="transparent" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default MiniAIIllustration;
